<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <Message message="" icon="coming_soon_cl.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'br'">
      <Message message="" icon="coming_soon_br.svg" :as-card="true" />
    </div>
    <div v-if="$i18n.locale === 'cl'">
      <div class="card-item mt-6 options">
        <div>
          <b-button
            id="existing-evaluation-button"
            :class="evaluationOption==='existing' ? 'is-primary' : ''"
            class="is-button-secondary"
            rounded
            @click="setEvaluationOption('existing')">
            Retomar
          </b-button>
          <div
            :class="evaluationOption==='existing' ? 'show' : 'hide'"
            class="card-item transition-fast selected-option-content mt-2">
            <FindEntitiesInput
              id="find-evaluations-input"
              placeholder="Buscar comprobación por RUT"
              show-date="true"
              :expanded="true"
              :finder="finder"
              class="search-evaluations"
              @select="clickedOnEvaluation($event)" />
          </div>
        </div>
        <div>
          <b-button
            id="new-evaluation-button"
            :class="evaluationOption==='new' ? 'is-primary' : ''"
            class="is-button-secondary"
            rounded
            @click="setEvaluationOption('new')">
            Nueva comprobación
          </b-button>
          <div
            :class="evaluationOption==='new' ? 'show' : 'hide'"
            class="card-item transition-fast selected-option-content mt-2">
            <div class="switch">
              <p>Guardar comprobación</p>
              <b-switch id="save-evaluation-switch" v-model="newEvaluation.save" size="is-small" />
            </div>
            <b-field
              v-if="newEvaluation.save"
              :message="newEvaluation.message">
              <b-input
                id="id-number-input"
                v-model="idNumber"
                icon-clickable
                placeholder="RUT a comprobar"
                size="is-small"
                rounded />
            </b-field>
            <b-button
              id="continue-evaluation-button"
              class="is-button-secondary"
              :disabled="newEvaluation.save && !newEvaluation.validIdNumber"
              :loading="newEvaluation.isLoading"
              rounded
              @click="continueNewEvaluation()">
              {{ newEvaluation.save ? 'Crear Comprobación' : 'Probar comprobador' }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { IdNumberValidatorCL } from 'creditu-types/validators/id-number';
import { createRiskEvaluation, getRiskEvaluationByIdNumber } from '@/application/services/api-clients/risk-evaluations';
import { getUtm, getUf } from '@/application/services/api-clients/indicators';
import notification from '@/ui/mixins/notification';
import FindEntitiesInput from '@/ui/components/internal/FindEntitiesInput.vue';
import { formattedToValue, valueToFormatted } from 'creditu-types/format';
import Message from '@/ui/components/Message.vue';

export default {
  name: 'RiskEvaluation',
  components: { FindEntitiesInput, Message },
  mixins: [notification],
  data() {
    return {
      evaluationOption: '',
      idNumber: '',
      unformattedIdNumber: '',
      newEvaluation: {
        save: true,
        isLoading: false,
        validIdNumber: false,
        message: ''
      },
      finder: getRiskEvaluationByIdNumber
    };
  },
  watch: {
    idNumber: {
      handler(newValue) {
        const unformattedNewValue = formattedToValue('idNumber', this.$i18n.locale, newValue);
        const formattedNewValue = valueToFormatted('idNumber', this.$i18n.locale, unformattedNewValue);
        const idNumberValidatorCL = new IdNumberValidatorCL();
        const validIdNumber = idNumberValidatorCL.validate(unformattedNewValue);

        this.idNumber = formattedNewValue;
        this.unformattedIdNumber = unformattedNewValue;
        this.newEvaluation.validIdNumber = validIdNumber;
        this.newEvaluation.message = validIdNumber ? '' : 'Ingresa un RUT válido';
      }
    }
  },
  methods: {
    setEvaluationOption(option) {
      this.evaluationOption = this.evaluationOption !== option ? option : '';
    },
    async getIndicators() {
      const utm = await getUtm();
      const uf = await getUf();
      return { utm, uf };
    },
    async clickedOnEvaluation(event) {
      const indicators = await this.getIndicators();
      this.$router.push({ name: 'evaluation', params: { evaluationId: event._id, indicators } });
    },
    async continueNewEvaluation() {
      const indicators = await this.getIndicators();
      if (this.newEvaluation.save && this.newEvaluation.validIdNumber) {
        try {
          this.newEvaluation.isLoading = true;
          const evaluationFromMongo = await createRiskEvaluation(this.unformattedIdNumber);
          if (!evaluationFromMongo.externalprovider.includes('FLOID')) {
            this.alert({ message: 'Prospecto proveniente de Floid no valido' });
          }
          this.$router.push({ name: 'evaluation', params: { evaluationId: evaluationFromMongo._id, indicators } });
          this.newEvaluation.isLoading = false;
        } catch (_error) {
          this.alert({ message: 'Hubo un error al tratar de comunicarnos con el servidor' });
          this.newEvaluation.isLoading = false;
        }
      } else if (!this.newEvaluation.save) {
        this.$router.push({ name: 'evaluation', params: { evaluationId: 'test', indicators } });
      }
    }
  }
};
</script>
<style scoped>
.options {
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(8rem, 1fr));
  place-items: start stretch;
  gap: 2rem;
}
.options > div {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
}
.hide {
  max-height: 0;
  overflow: hidden;
  padding: 0;
  opacity: 0;
}
.show {
  max-height: 100rem;
  overflow: hidden;
  border-radius: 1rem;
}
.selected-option-content {
  display: flex;
  flex-flow: column wrap;
  gap: 0.5rem;
}
.selected-option-content .switch {
  gap: 0.5rem;
  font-size: .9rem;
}
@media(max-width:480px) {
  .options {
    grid-template-columns: 1fr;
  }
}
</style>
